import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import Loading from '../../components/Loading';

import accountRouter from '../account';

const TunnelDashboardComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "tunnel-dashboard" */ '../../pages/tunnel-dashboard'
    ),
);

const tunnelDashboardRouter = (
  <Route path="tunnel-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <TunnelDashboardComponent />
        </Suspense>
      }
    >
      {accountRouter()}
    </Route>
  </Route>
);

export default tunnelDashboardRouter;
